import styled, { keyframes, css } from 'styled-components';

const spinnerAnimationDuration = '1.4s';
const animationCbFunction = 'cubic-bezier(0.46, 0.03, 0.52, 0.96)';
const spinnerAnimation = `${spinnerAnimationDuration} ${animationCbFunction} infinite`;

const blue02 = '#0077c5';
const blue04 = '#21abf6';
const blue05 = '#34bfff';
const green02 = '#2ca01c';
const green04 = '#7fd000';
const cgTeal04 = '#06b6c9';
const teal02 = '#00a6a4';
const teal05 = '#15efe9';
const cgLBlue = '#396598';
const pink02 = '#c9007a';

const data = {
  intuit: {
    primary: blue02,
    secondary: blue05
  },
  quickbooks: {
    primary: green02,
    secondary: green04
  },
  proconnect: {
    primary: blue02,
    secondary: blue04
  },
  turbotax: {
    primary: cgTeal04,
    secondary: cgTeal04
  },
  mint: {
    primary: teal02,
    secondary: teal05
  },
  ode: {
    primary: cgLBlue,
    secondary: cgLBlue
  },
  turbo: {
    primary: pink02,
    secondary: pink02
  }
};

const indeterminateShortRotation = keyframes`
  0% { transform: rotate(0deg); }
  8% { transform: rotate(0deg); }
  100% { transform: rotate(470deg); }
`;

const indeterminateShortCircleTranslateUp = keyframes`
  8% { transform: translateY(0); }
  50% { transform: translateY(-42%); }
  56% { transform: translateY(-42%); }
  100% { transform: translateY(0); }
`;

/**
 *
 */
const indeterminateShortCircleTransformsTheme = props =>
  keyframes`
    8% { transform: scale(1);  fill: ${data[props.theme].primary}}
    50% { transform: scale(0.6); fill: ${data[props.theme].secondary}}
    56% { transform: scale(0.6); fill: ${data[props.theme].secondary}}
    100% { transform: scale(1);  fill: ${data[props.theme].primary}}
`;

/**
 *
 */
const indeterminateShortCircleTransformsFill = props =>
  keyframes`
    8% { transform: scale(1);  fill: ${props.fill}
    50% { transform: scale(0.6); fill: ${props.fill}
    56% { transform: scale(0.6); fill: ${props.fill}
    100% { transform: scale(1);  fill: ${props.fill}
`;

const indeterminateShortCircleTransformsInverse = keyframes`
  8% { transform: scale(1);  fill: '#ffffff' }
  50% { transform: scale(0.6); fill: '#ffffff' }
  56% { transform: scale(0.6); fill: '#ffffff' }
  100% { transform: scale(1);  fill: '#ffffff' }
`;

export const Wrapper = styled.div`
  box-sizing: border-box;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  animation: ${spinnerAnimationDuration} linear ${indeterminateShortRotation};
  will-change: transform;
  animation-iteration-count: infinite;
  ${props =>
    props.size &&
    css`
      width: ${props.size}px;
      height: ${props.size}px;
    `};
`;

export const CircularSpinnerOuter = styled.div`
  position: absolute;
  &:nth-of-type(2) {
    transform: rotate(90deg);
  }
  &:nth-of-type(3) {
    transform: rotate(180deg);
  }
  &:nth-of-type(4) {
    transform: rotate(270deg);
  }
  ${props =>
    props.size &&
    css`
      width: ${props.size}px;
      height: ${props.size}px;
    `};
`;

export const CircularSpinnerInner = styled.div`
  animation: ${indeterminateShortCircleTranslateUp} ${spinnerAnimation};
  will-change: transform;
  ${props =>
    props.size &&
    css`
      width: ${props.size}px;
      height: ${props.size}px;
    `};
`;

export const SVG = styled.svg`
  position: absolute;
  will-change: transform;
  animation-iteration-count: infinite;
  ${props =>
    props.size &&
    css`
      width: ${props.size}px;
      height: ${props.size}px;
    `};
  ${props =>
    props.theme &&
    css`
      fill: ${data[props.theme].primary};
      animation: ${indeterminateShortCircleTransformsTheme} ${spinnerAnimation};
    `};
  ${props =>
    props.inverse &&
    css`
      fill: #ffffff;
      animation: ${indeterminateShortCircleTransformsInverse}
        ${spinnerAnimation};
    `};
  ${props =>
    props.fill &&
    css`
      fill: ${props.fill};
      animation: ${indeterminateShortCircleTransformsFill} ${spinnerAnimation};
    `}
`;
